// extracted by mini-css-extract-plugin
module.exports = {"header":"WorkspacesBox_header__1KxzO","box":"WorkspacesBox_box__2Y879","node":"WorkspacesBox_node__3lMHm"};